import React from 'react';
import styles from '../LayoutDetail.module.css';
import TabNavigation from './TabNavigation';
import DevicesTab from './DevicesTab';
import DetailTab from './DetailTab';

const ContentSection = ({
    activeTab,
    onTabChange,
    devices,
    typeFilter,
    selectedDevice,
    selectedLine,
    lines,
    setLines,
    loading,
    layoutId,
    onTypeFilterChange,
    onDeviceSelect,
    onDeviceEdit,
    onDeviceDelete,
    onUpdateDevice,
    onAddDevice,
    onAddLine,
    onEditLine,
    onLineSelect,
    onDeleteLine,
    onSignalChange,
    onAllBlinking
}) => {
    return (
        <div className={styles.contentSection}>
            <TabNavigation 
                activeTab={activeTab}
                onTabChange={onTabChange}
                devicesCount={devices?.length || 0}
            />

            {activeTab === 'devices' && (
                <DevicesTab
                    devices={devices}
                    typeFilter={typeFilter}
                    selectedDevice={selectedDevice}
                    onTypeFilterChange={onTypeFilterChange}
                    onDeviceSelect={onDeviceSelect}
                    onDeviceEdit={onDeviceEdit}
                    onDeviceDelete={onDeviceDelete}
                    onUpdateDevice={onUpdateDevice}
                    onAddDevice={onAddDevice}
                />
            )}

            {activeTab === 'detail' && (
                <DetailTab
                    lines={lines}
                    setLines={setLines}
                    loading={loading}
                    layoutId={layoutId}
                    selectedLine={selectedLine}
                    onLineSelect={onLineSelect}
                    onAddLine={onAddLine}
                    onEditLine={onEditLine}
                    onDeleteLine={onDeleteLine}
                    onSignalChange={onSignalChange}
                    onAllBlinking={onAllBlinking}
                />
            )}
        </div>
    );
};

export default ContentSection; 